// extracted by css-extract-rspack-plugin
export default {"cls1":"Truncate-cls1_d61","cls2":"Truncate-cls2_h01 Truncate-cls1_d61"};